var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpecialization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1FBFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 16.6667C11.6667 17.7848 18.4124 20.8333 19.9884 20.8333C21.5644 20.8333 28.3102 17.7848 28.3102 16.6667C28.3102 15.5485 21.5644 12.5 19.9884 12.5C18.4124 12.5 11.6667 15.5485 11.6667 16.6667Z",
    stroke: "#003E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9951 19.1667L15.1994 23.8582C15.2035 23.9522 15.2136 24.0462 15.2408 24.1362C15.325 24.4144 15.4801 24.6672 15.7167 24.837C17.5679 26.1654 22.4084 26.1654 24.2596 24.837C24.4963 24.6672 24.6513 24.4144 24.7355 24.1362C24.7627 24.0462 24.7728 23.9522 24.777 23.8582L24.9812 19.1667",
    stroke: "#003E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0612 17.9167V23.75M27.0612 23.75C26.4012 24.9552 26.1093 25.601 25.8129 26.6667C25.7486 27.0458 25.7997 27.2369 26.061 27.4066C26.1672 27.4755 26.2947 27.5 26.4212 27.5H27.6882C27.823 27.5 27.9589 27.4719 28.0698 27.3954C28.3127 27.2279 28.3752 27.0442 28.3094 26.6667C28.0496 25.6772 27.7186 25.0007 27.0612 23.75Z",
    stroke: "#003E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialization);
export default __webpack_public_path__ + "static/media/Specialization.66f5c7ac960dda56af1d2900bd376260.svg";
export { ForwardRef as ReactComponent };